import styled from 'styled-components';

const infoItemsGap = '32px';

export const Container = styled.div`
  border-top: solid 3px #185335;
  width: 100%;
  margin-top: 30px;
  box-shadow: 0px 10px 60px 0px rgb(0 0 0 / 10%),
    0px 0px 0px 1px rgb(0 0 0 / 1%);

  @media screen and (min-width: 992px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .banner,
  .info {
    padding: 30px;

    @media screen and (min-width: 992px) {
      flex: 1 1 50%;
    }
  }

  .banner {
    img {
      max-width: 100%;

      @media screen and (min-width: 992px) {
        max-width: 80%;
      }
    }
  }

  .info {
    &__title {
      font-weight: bold;
      font-size: 1.3rem;
      line-height: 1;
      margin: 0 0 ${infoItemsGap} 0;
    }

    &__description {
      display: block;
      font-size: 1.18rem;
      margin: 0 0 ${infoItemsGap} 0;
      line-height: 1.5;
    }

    &__action {
      display: inline-block;
      outline: none;
      border-radius: 6px;
      padding: 6px 10px;
      color: #fff;
      background-color: #185335;
      border: solid 1px #185335;

      &:hover {
        background-color: #12482d;
        border: solid 1px #12482d;
      }
    }
  }
`;
